import React from 'react';
import { CheckCircle } from '@material-ui/icons';

const defaultChefImg = "/images/simple-chef.webp";

const DishComponent = ({ dish, handleClick, selectedDishes }) => {
  const isSelected = selectedDishes.findIndex(item => item.dishId === dish.id);
  return (<div className={`dish-single-item-booking ${isSelected > -1 ? 'dish-booking-selected' : ''}`} onClick={() => handleClick(dish.id)}>
    <img src={dish.media ? dish.media.length > 0 ? dish.media[0].url : defaultChefImg : defaultChefImg} />
    <div className="dish-details">
      <h3>{dish.name}</h3>
      <span>{dish.cuisines.join(', ')}</span>
      <div className="dish-info">
        <div>Serves: <span>{dish.minDinerSize}</span></div>
        <div>Price: $<span>{dish.minPrice}</span></div>
      </div>
    </div>
    {isSelected > -1 && <CheckCircle />}
  </div>);
};

export default DishComponent;
